import AgeSlider from "./AgeSlider";
export default AgeSlider;